import { useState, useEffect } from "react";
import http from "../pages/http-common";

export default function useCommunityStats() {
  const [stats, setStats] = useState({
    activeMembers: 102,
    totalMembers: 102,
    displayText: "102+ Diversified Members",
    loading: true,
  });

  useEffect(() => {
    let isMounted = true;
    http
      .get("/auth/community-stats")
      .then((res) => {
        if (isMounted && res.data && (res.data.activeMembers || res.data.totalMembers)) {
          const count = res.data.activeMembers || res.data.totalMembers;
          setStats({
            activeMembers: count,
            totalMembers: res.data.totalMembers || count,
            displayText: `${count}+ Diversified Members`,
            loading: false,
          });
        }
      })
      .catch(() => {
        if (isMounted) {
          setStats((prev) => ({ ...prev, loading: false }));
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return stats;
}
